import { render, staticRenderFns } from "./IconUserGroup.vue?vue&type=template&id=5c0e9eef&"
import script from "./IconUserGroup.vue?vue&type=script&lang=ts&"
export * from "./IconUserGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports